import qs from "querystring";

function deserializeQuery(query = "") {
  if (query.search(/\?|&/) === 0) {
    query = query.substr(1);
  }

  return qs.parse(query);
}

export default deserializeQuery;



// WEBPACK FOOTER //
// ./utils/deserializeQuery.js